import { connect } from 'react-redux';
import { getMessageState } from '../../redux/selectors/messageStates';
const mapStateToProps = (state, props)=>({
        isLoading: getMessageState(state, props.notification.messageId).isLoading
    });
export default connect(mapStateToProps);
